export default {"src":"__ASTRO_ASSET_IMAGE__C8De7tJ___","width":58,"height":43,"format":"svg"}